module.exports = __webpack_public_path__ + "img/Registration_Welcome_Image.10c13492.png";